import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class PackagingStockMovementHistoryService extends Service {
	constructor(injector: Injector) {
		super("PackagingStockMovementHistory", injector);
	}

	// API
	getByPackagingId(packagingId: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByPackagingId/${packagingId}`);
	}
}